export default __webpack_public_path__ + "static/media/hearth.9f081e04.svg";